import { createRESTConn } from "../../../Common";
import { ConnectionNames } from "../../../Contracts";
import { BetsReportingRequestFormatter } from "../BetsReportingRequestFormatter";
export function createBetsReportingConnection() {
    return createRESTConn({
        name: ConnectionNames.betsReporting,
        handlers: {
            requestFormatter: BetsReportingRequestFormatter
        }
    });
}
//# sourceMappingURL=CreateBetsReportingConnection.js.map